import { bug_products } from './products';


export const pqs_1 = [
  {
    'is_sold': false,
    'id': 'A1002',
    'validatingCarrier': 'UA',
    'travelCarePrice': 572.01,
    'priceOffer': 19006.5,
    'priceOfferPerOne': '4,085.75',
    'price': {
      'whole': '4,085',
      'decimals': '75',
      'currency': 'USD'
    },
    'taxes': {
      'airline': 1170,
      'tbc': 7001.5
    },
    'badge': null,
    'passengers': {'adult': 1, 'child': 0, 'infant': 0, 'all': 1},
    'available_airlines': ['123', '97'],
    'parts': {
      'multiple': false,
      'depart': {
        'from': 'MSP',
        'to': 'CAI',
        'date': 'Thu, Oct 13',
        'travelTime': '16h 35m',
        'stops': 2,
        'baggage': 0,
        'baggageWeight': 70,
        'flightClass': 'Business',
        'segments': [
          {
            'id': 1,
            'departure': {
              'airport': 'MSP',
              'date': 'Thu, Oct 13',
              'time': '10:30 AM',
              'terminal': 'TERMINAL 1 - LINDBERGH'
            },
            'arrival': {'airport': 'YYZ', 'date': 'Thu, Oct 13', 'time': '01:29 PM', 'terminal': 'TERMINAL 1'},
            'duration': '01h 59m',
            'carrier': {'airline': 'AC', 'code': 'AC 8718', 'type': 'Business', 'plane': 'Embraer 175'},
            'layover': {'duration': '1h 31m', 'isTechnical': 0, 'isAirportChange': false, 'airport': 'YYZ'},
            'meal': 1,
            'meal_type': null,
            'operated_by': '',
            'baggage_weight': 70,
            'baggage_quantity': [1, 1],
            'baggage_count': 2
          }, {
            'id': 2,
            'departure': {'airport': 'YYZ', 'date': 'Thu, Oct 13', 'time': '03:00 PM', 'terminal': 'TERMINAL 1'},
            'arrival': {'airport': 'YUL', 'date': 'Thu, Oct 13', 'time': '04:16 PM', 'terminal': null},
            'duration': '01h 16m',
            'carrier': {'airline': 'AC', 'code': 'AC 416', 'type': 'Business', 'plane': 'Airbus A320'},
            'layover': {'duration': '1h 44m', 'isTechnical': 0, 'isAirportChange': false, 'airport': 'YUL'},
            'meal': 1,
            'meal_type': null,
            'operated_by': '',
            'baggage_weight': 70,
            'baggage_quantity': [1, 1],
            'baggage_count': 2
          }, {
            'id': 3,
            'departure': {'airport': 'YUL', 'date': 'Thu, Oct 13', 'time': '06:00 PM', 'terminal': null},
            'arrival': {'airport': 'CAI', 'date': 'Fri, Oct 14', 'time': '10:05 AM', 'terminal': 'TERMINAL 3'},
            'duration': '10h 05m',
            'carrier': {'airline': 'AC', 'code': 'AC 74', 'type': 'Business', 'plane': 'Boeing 787-800'},
            'layover': null,
            'meal': 1,
            'meal_type': null,
            'operated_by': '',
            'baggage_weight': 70,
            'baggage_quantity': [1, 1],
            'baggage_count': 2
          }
        ]
      },
      'return': {
        'from': 'TLV',
        'to': 'MSP',
        'date': 'Thu, Oct 13',
        'travelTime': '16h 35m',
        'stops': 1,
        'baggage': 0,
        'baggageWeight': 70,
        'flightClass': 'Business',
        'segments': [
          {
            'id': 4,
            'departure': {
              'airport': 'TLV',
              'date': 'Sat, Oct 29',
              'time': '11:45 AM',
              'terminal': 'TERMINAL 3 INTL'
            },
            'arrival': {'airport': 'YYZ', 'date': 'Sat, Oct 29', 'time': '04:25 PM', 'terminal': 'TERMINAL 1'},
            'duration': '11h 40m',
            'carrier': {'airline': 'AC', 'code': 'AC 81', 'type': 'Business', 'plane': 'Boeing 787-900'},
            'layover': null,
            'meal': 1,
            'meal_type': null,
            'operated_by': '',
            'baggage_weight': 70,
            'baggage_quantity': [1, 1],
            'baggage_count': 2
          }, {
            'id': 7,
            'departure': {'airport': 'YYZ', 'date': 'Sat, Oct 29', 'time': '08:45 PM', 'terminal': 'TERMINAL 1'},
            'arrival': {
              'airport': 'MSP',
              'date': 'Sat, Oct 29',
              'time': '09:53 PM',
              'terminal': 'TERMINAL 1 - LINDBERGH'
            },
            'duration': '02h 08m',
            'carrier': {'airline': 'AC', 'code': 'AC 8721', 'type': 'Business', 'plane': 'Embraer 175'},
            'layover': null,
            'meal': 1,
            'meal_type': null,
            'operated_by': '',
            'baggage_weight': 70,
            'baggage_quantity': [1, 1],
            'baggage_count': 2
          }
        ]
      }
    },
    'link': '',
    'manualSplit': false,
    'products': bug_products
  }

]

export const pqs_2 = [
  {
    'id': 'A1002',
    'is_sold': false,
    //
    'checkPaymentPs': 0,
    'travelCarePrice': 572.01,
    'priceOffer': 12000,
    'priceOfferPerOne': 12000,
    'price': {'whole': '12,000', 'decimals': '00', 'currency': 'USD'},
    'taxes': {
      'airline': 6000,
      'tbc': 6000
    },
    'manualSplit': false,
    'products': bug_products,
    //

    'validatingCarrier': 'UA',
    'clientRemark': 'Best price',
    'badge': null,
    'passengers': {'adult': 1, 'child': 0, 'infant': 0, 'all': 1},
    'available_airlines': ['123', '97'],
    'bo_reference': '234567',
    'parts': {
      'multiple': false,
      'depart': {
        'from': 'MSP',
        'to': 'CAI',
        'date': 'Thu, Oct 13',
        'departure_at': '1734628352',
        'travelTime': '16h 35m',
        'stops': 2,
        'baggage': 0,
        'baggageWeight': 70,
        'flightClass': 'Business',
        'segments': [
          {
            'id': 1,
            'departure': {
              'airport': 'MSP',
              'date': 'Thu, Oct 13',
              'time': '10:30 AM',
              'terminal': 'TERMINAL 1 - LINDBERGH'
            },
            'arrival': {'airport': 'YYZ', 'date': 'Thu, Oct 13', 'time': '01:29 PM', 'terminal': 'TERMINAL 1'},
            'duration': '01h 59m',
            'carrier': {'airline': 'AC', 'code': 'AC 8718', 'type': 'Business', 'plane': 'Embraer 175'},
            'layover': {'duration': '1h 31m', 'isTechnical': 0, 'isAirportChange': false, 'airport': 'YYZ'},
            'meal': 1,
            'meal_type': null,
            'operated_by': '',
            'baggage_weight': 70,
            'baggage_quantity': [1, 1],
            'baggage_count': 2
          }, {
            'id': 2,
            'departure': {'airport': 'YYZ', 'date': 'Thu, Oct 13', 'time': '03:00 PM', 'terminal': 'TERMINAL 1'},
            'arrival': {'airport': 'YUL', 'date': 'Thu, Oct 13', 'time': '04:16 PM', 'terminal': null},
            'duration': '01h 16m',
            'carrier': {'airline': 'AC', 'code': 'AC 416', 'type': 'Business', 'plane': 'Airbus A320'},
            'layover': {'duration': '1h 44m', 'isTechnical': 0, 'isAirportChange': false, 'airport': 'YUL'},
            'meal': 1,
            'meal_type': null,
            'operated_by': '',
            'baggage_weight': 70,
            'baggage_quantity': [1, 1],
            'baggage_count': 2
          }, {
            'id': 3,
            'departure': {'airport': 'YUL', 'date': 'Thu, Oct 13', 'time': '06:00 PM', 'terminal': null},
            'arrival': {'airport': 'CAI', 'date': 'Fri, Oct 14', 'time': '10:05 AM', 'terminal': 'TERMINAL 3'},
            'duration': '10h 05m',
            'carrier': {'airline': 'AC', 'code': 'AC 74', 'type': 'Business', 'plane': 'Boeing 787-800'},
            'layover': null,
            'meal': 1,
            'meal_type': null,
            'operated_by': '',
            'baggage_weight': 70,
            'baggage_quantity': [1, 1],
            'baggage_count': 2
          }
        ]
      },
      'return': {
        'from': 'TLV',
        'to': 'MSP',
        'date': 'Thu, Oct 13',
        'travelTime': '16h 35m',
        'stops': 1,
        'baggage': 0,
        'baggageWeight': 70,
        'flightClass': 'Business',
        'segments': [
          {
            'id': 4,
            'departure': {
              'airport': 'TLV',
              'date': 'Sat, Oct 29',
              'time': '11:45 AM',
              'terminal': 'TERMINAL 3 INTL'
            },
            'arrival': {'airport': 'YYZ', 'date': 'Sat, Oct 29', 'time': '04:25 PM', 'terminal': 'TERMINAL 1'},
            'duration': '11h 40m',
            'carrier': {'airline': 'AC', 'code': 'AC 81', 'type': 'Business', 'plane': 'Boeing 787-900'},
            'layover': null,
            'meal': 1,
            'meal_type': null,
            'operated_by': '',
            'baggage_weight': 70,
            'baggage_quantity': [1, 1],
            'baggage_count': 2
          }, {
            'id': 7,
            'departure': {'airport': 'YYZ', 'date': 'Sat, Oct 29', 'time': '08:45 PM', 'terminal': 'TERMINAL 1'},
            'arrival': {
              'airport': 'MSP',
              'date': 'Sat, Oct 29',
              'time': '09:53 PM',
              'terminal': 'TERMINAL 1 - LINDBERGH'
            },
            'duration': '02h 08m',
            'carrier': {'airline': 'AC', 'code': 'AC 8721', 'type': 'Business', 'plane': 'Embraer 175'},
            'layover': null,
            'meal': 1,
            'meal_type': null,
            'operated_by': '',
            'baggage_weight': 70,
            'baggage_quantity': [1, 1],
            'baggage_count': 2
          }
        ]
      }
    },
    'link': '',
    'recommendedOption': false
  },
  {
    'id': 'A1003',
    'is_sold': false,

    //
    // 'checkPaymentPs': 0.035, // An old pq, no property.
    'travelCarePrice': 350,
    'priceOffer': 12000,
    'priceOfferPerOne': 12000,
    'price': {'whole': '12,000', 'decimals': '00', 'currency': 'USD'},
    'taxes': {
      'airline': 6000,
      'tbc': 6000
    },
    'manualSplit': false,
    'products': bug_products,
    //

    'validatingCarrier': 'AC',

    'clientRemark': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque non neque vel leo facilisis varius. Fusce auctor, enim ut hendrerit malesuada, lectus libero elementum tortor, in convallis nulla nulla non mauris. Vivamus volutpat vehicula.',

    'badge': null,
    'passengers': {'adult': 1, 'child': 0, 'infant': 0, 'all': 1},
    'available_airlines': ['123', '97'],
    'parts': {
      'multiple': false,
      'depart': {
        'from': 'MSP',
        'to': 'CAI',
        'date': 'Thu, Oct 13',
        'travelTime': '16h 35m',
        'stops': 2,
        'baggage': 0,
        'baggageWeight': 70,
        'flightClass': 'Business',
        'segments': [
          {
            'id': 345,
            'departure': {
              'airport': 'MSP',
              'date': 'Thu, Oct 13',
              'time': '10:30 AM',
              'terminal': 'TERMINAL 1 - LINDBERGH'
            },
            'arrival': {'airport': 'YYZ', 'date': 'Thu, Oct 13', 'time': '01:29 PM', 'terminal': 'TERMINAL 1'},
            'duration': '01h 59m',
            'carrier': {'airline': 'AC', 'code': 'AC 8718', 'type': 'Business', 'plane': 'Embraer 175'},
            'layover': {'duration': '1h 31m', 'isTechnical': 0, 'isAirportChange': false, 'airport': 'YYZ'},
            'meal': 1,
            'meal_type': null,
            'operated_by': '',
            'baggage_weight': 70,
            'baggage_quantity': [1, 1],
            'baggage_count': 2
          },
          {
            'id': 678,
            'departure': {'airport': 'YYZ', 'date': 'Thu, Oct 13', 'time': '03:00 PM', 'terminal': 'TERMINAL 1'},
            'arrival': {'airport': 'YUL', 'date': 'Thu, Oct 13', 'time': '04:16 PM', 'terminal': null},
            'duration': '01h 16m',
            'carrier': {'airline': 'AC', 'code': 'AC 416', 'type': 'Business', 'plane': 'Airbus A320'},
            'layover': {'duration': '1h 44m', 'isTechnical': 0, 'isAirportChange': false, 'airport': 'YUL'},
            'meal': 1,
            'meal_type': null,
            'operated_by': '',
            'baggage_weight': 70,
            'baggage_quantity': [1, 1],
            'baggage_count': 2
          },
          {
            'id': 456,
            'departure': {'airport': 'YUL', 'date': 'Thu, Oct 13', 'time': '06:00 PM', 'terminal': null},
            'arrival': {'airport': 'CAI', 'date': 'Fri, Oct 14', 'time': '10:05 AM', 'terminal': 'TERMINAL 3'},
            'duration': '10h 05m',
            'carrier': {'airline': 'AC', 'code': 'AC 74', 'type': 'Business', 'plane': 'Boeing 787-800'},
            'layover': null,
            'meal': 1,
            'meal_type': null,
            'operated_by': '',
            'baggage_weight': 70,
            'baggage_quantity': [1, 1],
            'baggage_count': 2
          }
        ]
      },
      'return': {
        'from': 'TLV',
        'to': 'MSP',
        'date': 'Thu, Oct 13',
        'travelTime': '16h 35m',
        'stops': 1,
        'baggage': 0,
        'baggageWeight': 70,
        'flightClass': 'Business',
        'segments': [
          {
            'id': 5467,
            'departure': {
              'airport': 'TLV',
              'date': 'Sat, Oct 29',
              'time': '11:45 AM',
              'terminal': 'TERMINAL 3 INTL'
            },
            'arrival': {'airport': 'YYZ', 'date': 'Sat, Oct 29', 'time': '04:25 PM', 'terminal': 'TERMINAL 1'},
            'duration': '11h 40m',
            'carrier': {'airline': 'AC', 'code': 'AC 81', 'type': 'Business', 'plane': 'Boeing 787-900'},
            'layover': null,
            'meal': 1,
            'meal_type': null,
            'operated_by': '',
            'baggage_weight': 70,
            'baggage_quantity': [1, 1],
            'baggage_count': 2
          },
          {
            'id': 347452,
            'departure': {'airport': 'YYZ', 'date': 'Sat, Oct 29', 'time': '08:45 PM', 'terminal': 'TERMINAL 1'},
            'arrival': {
              'airport': 'MSP',
              'date': 'Sat, Oct 29',
              'time': '09:53 PM',
              'terminal': 'TERMINAL 1 - LINDBERGH'
            },
            'duration': '02h 08m',
            'carrier': {'airline': 'AC', 'code': 'AC 8721', 'type': 'Business', 'plane': 'Embraer 175'},
            'layover': null,
            'meal': 1,
            'meal_type': null,
            'operated_by': '',
            'baggage_weight': 70,
            'baggage_quantity': [1, 1],
            'baggage_count': 2
          }
        ]
      }
    },
    'link': '',

    'recommendedOption': true
  }
  // {
  //   'is_sold': true,
  //   'id': 'AP1004',
  //   'validatingCarrier': 'AC',
  //   'travelCarePrice': 350,
  //   'priceOffer': 500,
  //   'priceOfferPerOne': 500,
  //   'clientRemark': 'Best service',
  //   'price': {'whole': '500', 'decimals': '0'},
  //   'taxes': {'airline': 0, 'tbc': 0},
  //   'badge': null,
  //   'passengers': {'adult': 1, 'child': 0, 'infant': 0, 'all': 1},
  //   'available_airlines': ['123', '97'],
  //   'parts': {
  //     'multiple': false,
  //     'depart': {
  //       'from': 'MSP',
  //       'to': 'CAI',
  //       'date': 'Thu, Oct 13',
  //       'travelTime': '16h 35m',
  //       'stops': 2,
  //       'baggage': 0,
  //       'baggageWeight': 70,
  //       'flightClass': 'Business',
  //       'segments': [{
  //         'id': 35678357,
  //         'departure': {
  //           'airport': 'MSP',
  //           'date': 'Thu, Oct 13',
  //           'time': '10:30 AM',
  //           'terminal': 'TERMINAL 1 - LINDBERGH'
  //         },
  //         'arrival': {'airport': 'YYZ', 'date': 'Thu, Oct 13', 'time': '01:29 PM', 'terminal': 'TERMINAL 1'},
  //         'duration': '01h 59m',
  //         'carrier': {'airline': 'AC', 'code': 'AC 8718', 'type': 'Business', 'plane': 'Embraer 175'},
  //         'layover': {'duration': '1h 31m', 'isTechnical': 0, 'isAirportChange': false, 'airport': 'YYZ'},
  //         'meal': 1,
  //         'meal_type': null,
  //         'operated_by': '',
  //         'baggage_weight': 70,
  //         'baggage_quantity': [1, 1],
  //         'baggage_count': 2
  //       }, {
  //         'id': 456243,
  //         'departure': {'airport': 'YYZ', 'date': 'Thu, Oct 13', 'time': '03:00 PM', 'terminal': 'TERMINAL 1'},
  //         'arrival': {'airport': 'YUL', 'date': 'Thu, Oct 13', 'time': '04:16 PM', 'terminal': null},
  //         'duration': '01h 16m',
  //         'carrier': {'airline': 'AC', 'code': 'AC 416', 'type': 'Business', 'plane': 'Airbus A320'},
  //         'layover': {'duration': '1h 44m', 'isTechnical': 0, 'isAirportChange': false, 'airport': 'YUL'},
  //         'meal': 1,
  //         'meal_type': null,
  //         'operated_by': '',
  //         'baggage_weight': 70,
  //         'baggage_quantity': [1, 1],
  //         'baggage_count': 2
  //       }, {
  //         'id': 36734,
  //         'departure': {'airport': 'YUL', 'date': 'Thu, Oct 13', 'time': '06:00 PM', 'terminal': null},
  //         'arrival': {'airport': 'CAI', 'date': 'Fri, Oct 14', 'time': '10:05 AM', 'terminal': 'TERMINAL 3'},
  //         'duration': '10h 05m',
  //         'carrier': {'airline': 'AC', 'code': 'AC 74', 'type': 'Business', 'plane': 'Boeing 787-800'},
  //         'layover': null,
  //         'meal': 1,
  //         'meal_type': null,
  //         'operated_by': '',
  //         'baggage_weight': 70,
  //         'baggage_quantity': [1, 1],
  //         'baggage_count': 2
  //       }]
  //     },
  //     'return': {
  //       'from': 'TLV',
  //       'to': 'MSP',
  //       'date': 'Thu, Oct 13',
  //       'travelTime': '16h 35m',
  //       'stops': 1,
  //       'baggage': 0,
  //       'baggageWeight': 70,
  //       'flightClass': 'Business',
  //       'segments': [{
  //         'id': 217245,
  //         'departure': {
  //           'airport': 'TLV',
  //           'date': 'Sat, Oct 29',
  //           'time': '11:45 AM',
  //           'terminal': 'TERMINAL 3 INTL'
  //         },
  //         'arrival': {'airport': 'YYZ', 'date': 'Sat, Oct 29', 'time': '04:25 PM', 'terminal': 'TERMINAL 1'},
  //         'duration': '11h 40m',
  //         'carrier': {'airline': 'AC', 'code': 'AC 81', 'type': 'Business', 'plane': 'Boeing 787-900'},
  //         'layover': null,
  //         'meal': 1,
  //         'meal_type': null,
  //         'operated_by': '',
  //         'baggage_weight': 70,
  //         'baggage_quantity': [1, 1],
  //         'baggage_count': 2
  //       }, {
  //         'id': 124752456,
  //         'departure': {'airport': 'YYZ', 'date': 'Sat, Oct 29', 'time': '08:45 PM', 'terminal': 'TERMINAL 1'},
  //         'arrival': {
  //           'airport': 'MSP',
  //           'date': 'Sat, Oct 29',
  //           'time': '09:53 PM',
  //           'terminal': 'TERMINAL 1 - LINDBERGH'
  //         },
  //         'duration': '02h 08m',
  //         'carrier': {'airline': 'AC', 'code': 'AC 8721', 'type': 'Business', 'plane': 'Embraer 175'},
  //         'layover': null,
  //         'meal': 1,
  //         'meal_type': null,
  //         'operated_by': '',
  //         'baggage_weight': 70,
  //         'baggage_quantity': [1, 1],
  //         'baggage_count': 2
  //       }]
  //     }
  //   },
  //   'link': '',
  //   'manualSplit': false,
  //   'products': bug_products,
  //   'recommendedOption': false
  // }
]
